
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { KanbanState } from '../kanban.model';
import { Card } from '../../backend/backendapi';
import { formatDateTime, WindowType } from '../../../util';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'ReadConfirmationsModal',
  components: {
  },
})
export default class CardReadConfirmationsModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  
  card: Card | null = null;
  formatDateTime = formatDateTime;

  public open(card: Card): void {
    this.card = card;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
